package com.hyperether.goodjob.map

import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.runtime.mutableStateOf
import com.hyperether.goodjob.repository.remote.model.LatLng

@Composable
expect fun MapComponent(
    showMapWeb: State<Boolean> = mutableStateOf(false),
    showMap: Boolean = true,
    markers: List<Marker>,
    currentPosition: State<LatLng?>,
    mapZoom: State<Boolean?> = mutableStateOf(null),
    onMapPanned: (Double, Double) -> Unit = { lat: Double, lon: Double -> }
)

data class Marker(
    val lat: Double,
    val lng: Double,
    val title: String,
    val status: String = "",
    var selected: Boolean = false
)
